module.exports = __webpack_public_path__ + "static/media/money-slip.2772954f.svg";